module.exports = __webpack_public_path__ + "static/media/test-fork.e3c88a8c.jpg";